(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qo-article"] && !Shopify.designMode) return;
  try {
    
(function () {

  var artBody = document.getElementById('qo-art-content');
  if (artBody) {
    var firstEl = artBody.firstElementChild;
    if (firstEl && (firstEl.tagName === 'H1' || firstEl.tagName === 'H2')) {
      var bannerTitle = document.querySelector('.qo-art__title');
      if (bannerTitle && firstEl.textContent.trim().toLowerCase() === bannerTitle.textContent.trim().toLowerCase()) {
        firstEl.remove();
      }
    }
  }

  var progress = document.getElementById('qo-art-progress');
  var content  = document.getElementById('qo-art-content');
  if (progress && content) {
    function updateProgress() {
      var rect     = content.getBoundingClientRect();
      var top      = rect.top + window.scrollY;
      var bottom   = rect.bottom + window.scrollY;
      var scrolled = window.scrollY - top;
      var total    = (bottom - top) - window.innerHeight;
      var pct      = total > 0 ? Math.min(100, Math.max(0, (scrolled / total) * 100)) : 0;
      progress.style.width = pct + '%';
      progress.setAttribute('aria-valuenow', Math.round(pct));
    }
    window.addEventListener('scroll', updateProgress, { passive: true });
    updateProgress();
  }

  var animated = document.querySelectorAll('.qo-art__animate');
  if ('IntersectionObserver' in window && animated.length) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('qo-art__animate--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    animated.forEach(function(el) { observer.observe(el); });
  } else {
    animated.forEach(function(el) { el.classList.add('qo-art__animate--visible'); });
  }

  var input = document.getElementById('qo-cta-qty');
  if (input) {
    var min   = parseInt(input.dataset.min)  || 12;
    var step  = parseInt(input.dataset.step) || 12;
    var link  = input.dataset.link || (window.__localeRoot || '/') + 'pages/catalogue';
    var minus = document.getElementById('qo-cta-minus');
    var plus  = document.getElementById('qo-cta-plus');
    var btn   = document.getElementById('qo-cta-submit');
    var errEl = document.getElementById('qo-cta-error');

    function clearMsg() {
      if (errEl) errEl.classList.remove('qo-art__qty-error--visible', 'qo-art__qty-error--warn');
      input.classList.remove('qo-art__qty-input--error', 'qo-art__qty-input--warn');
    }

    function showWarn() {
      if (!errEl) return;
      errEl.textContent = errEl.dataset.warn || ('Minimum recommandé : ' + min + ' unités');
      errEl.classList.remove('qo-art__qty-error--visible', 'qo-art__qty-error--warn');
      void errEl.offsetWidth;
      errEl.classList.add('qo-art__qty-error--visible', 'qo-art__qty-error--warn');
      input.classList.remove('qo-art__qty-input--error');
      input.classList.add('qo-art__qty-input--warn');
    }

    function showError() {
      if (!errEl) return;
      errEl.textContent = errEl.dataset.err || 'Veuillez entrer une quantité.';
      errEl.classList.remove('qo-art__qty-error--visible', 'qo-art__qty-error--warn');
      void errEl.offsetWidth;
      errEl.classList.add('qo-art__qty-error--visible');
      input.classList.remove('qo-art__qty-input--warn');
      input.classList.add('qo-art__qty-input--error');
      input.focus();
    }

    if (minus) minus.addEventListener('click', function() {
      var cur  = parseInt(input.value) || min;
      var next = Math.max(min, cur - step);
      input.value = next;
      clearMsg();
    });

    if (plus) plus.addEventListener('click', function() {
      var cur  = parseInt(input.value) || 0;
      var next = cur < min ? min : cur + step;
      input.value = next;
      clearMsg();
    });

    input.addEventListener('input', function() {
      var qty = parseInt(input.value);
      if (!input.value || !qty) { clearMsg(); return; }
      qty < min ? showWarn() : clearMsg();
    });

    if (btn) btn.addEventListener('click', function(e) {
      e.preventDefault();
      var qty = parseInt(input.value);
      if (!qty || qty < min) { showError(); return; }
      window.location.href = link + '?quantity=' + qty;
    });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qo-services-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const cards  = document.querySelectorAll('.qo-svp__card');
    const panels = document.querySelectorAll('.qo-svp__panel');
    const wrap   = document.getElementById('qo-svp-articles');

    cards.forEach(function(card) {
      card.addEventListener('click', function() {
        const idx = parseInt(card.dataset.idx);

        cards.forEach(function(c) { c.classList.remove('is-selected'); });
        panels.forEach(function(p) { p.classList.remove('is-active'); });

        card.classList.add('is-selected');
        if (panels[idx]) panels[idx].classList.add('is-active');

        if (wrap && window.innerWidth > 768) {
          setTimeout(function() {
            wrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 100);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qo-services"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var videos = document.querySelectorAll('.qo-sv .qo-sv__media-el');
    videos.forEach(function(v) {
      v.muted = true;
      v.play().catch(function() {});
    });
  });

  } catch(e) { console.error(e); }
})();
})();
